import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';
import { get } from '../../../utilities/tips';
import _ from 'lodash';

const reducer = (state, action) => {
  switch (action.type) {
    case types.REQUESTING: {
      return { ...state, requesting: action.requesting };
    }

    case types.CLEAR_SUCCESS_ERROR_FLAGS:
    case types.RESET_CANDIDATES_LIST:
    case types.RESET_DATA_LCI_MONITORING:
    case types.RESET_DATA: {
      return {};
    }

    case types.CANDIDATE_JOIN_INTERVIEW : {
      const { uid, roomId } = action.data;
      const candidates = state.candidates || [];
      const indexIfExisted = _.findIndex(candidates, { id: parseInt(uid) });
      if (indexIfExisted !== -1) {
        const existed = candidates[indexIfExisted];
        const updateInfo = {
          ...existed,
          roomId,
          trySelfJoin: action.data.trySelfJoin,
          sid: action.data.sid,
          candidateChannelARN: action.data.channelARN,
          online: true
        };
        candidates.splice(indexIfExisted, 1, updateInfo);
        return state;
      }

      candidates.push({ ...action.data, id: parseInt(action.data.uid), online: true });
      return { ...state, candidates };
    }

    case types.INTERVIEWER_JOIN_INTERVIEW : {
      return { ...state, interviewerChannelARN: action.data.channelARN };
    }

    case types.MESSAGE: {
      const messageRoom = `MESSAGE_${action.data.toRoomId}`;
      const currentMessages = state[messageRoom] || [];
      currentMessages.push(action.data);
      state[messageRoom] = currentMessages;
      return { ...state, latestMessage: action.data };
    }

    case types.CLEAR_LATEST_MESSAGE: {
      delete state.latestMessage;
      return state;
    }

    case types.GET_ALL_CANDIDATES_FOR_LCI: {
      return state;
    }

    case types.GET_ALL_CANDIDATES_FOR_LCI_SUCCESS: {
      return { ...state, candidates: action.result };
    }

    case types.GET_ALL_CANDIDATES_FOR_LCI_ERROR: {
      return { ...state, candidates: [] };
    }

    case types.REPLAY_DATA: {
      if (!state.allEvents) state.allEvents = [];
      state.allEvents.push(action.data);

      return state;
    }

    case types.END_LCI: {
      return state;
    }

    case types.END_LCI_ERROR: {
      return { ...state, endLCIMessage: { type: 'error' } };
    }

    case types.END_LCI_SUCCESS: {
      return { ...state, endLCIMessage: { type: 'success' } };
    }

    case types.SAVE_NOTE: {
      const submissionNotes = state.submissionNotes || [];
      const findIndex = _.findIndex(submissionNotes,
        (s) => s.userId === action.userId && s.lcId === action.lcId
      );
      delete action.type;
      if (findIndex === -1) submissionNotes.push({ ...action });
      else submissionNotes.splice(findIndex, 1, { ...action });

      return { ...state, submissionNotes };
    }

    case types.SUBMIT_NOTE: {
      return { ...state, submitingNote: true, submitNoteMessage: null };
    }

    case types.SUBMIT_NOTE_SUCCESS: {
      return { ...state, submitingNote: false, submitNoteMessage: { type: 'success' } };
    }

    case types.SUBMIT_NOTE_ERROR: {
      return { ...state, submitingNote: false, submitNoteMessage: { type: 'error' } };
    }

    case types.GET_LATEST_SUBMIT_INFO: {
      return { ...state, loadingLatestSubmit: true };
    }

    case types.GET_LATEST_SUBMIT_INFO_SUCCESS: {
      const info = get(['result', 0], action) || {};
      const submissionNotes = state.submissionNotes || [];
      const match = submissionNotes.filter(s => s.userId === info.userId && s.lcId === info.lcId);
      if (match.length === 0) {
        submissionNotes.push({ ...info });
      } else {
        match[0] = { ...info };
      }

      return { ...state, submissionNotes, loadingLatestSubmit: false };
    }

    case types.GET_LATEST_SUBMIT_INFO_ERROR: {
      return {
        ...state,
        loadingLatestSubmit: false
      };
    }

    case types.SEND_AUDIO_SWITCH: {
      const enableAudioViewers = state.enableAudioViewers || [];
      const existedIndex = _.findIndex(enableAudioViewers, (e) => e === action.remoteClientId);
      if (existedIndex === -1) enableAudioViewers.push(action.remoteClientId);
      else enableAudioViewers.splice(existedIndex, 1);

      return { ...state, enableAudioViewers };
    }

    case types.LOCAL_AUDIO_SWITCH: {
      if (state.localAudioOff === 'YES')state.localAudioOff = 'NO';
      else state.localAudioOff = 'YES';

      return { ...state };
    }

    case types.LOCAL_VIDEO_SWITCH: {
      if (state.localVideoOff === 'YES')state.localVideoOff = 'NO';
      else state.localVideoOff = 'YES';

      return { ...state };
    }

    case types.REPLAYER_DIMENSION: {
      const replayer = state.replayer || {};
      replayer[`replayer_${action.id}`] = action.dimension;
      return { ...state, replayer };
    }

    case types.REPLAYER_MAX_MIN: {
      let replayerMaxMin = state.replayerMaxMin || {};
      if (replayerMaxMin.maxmin) delete replayerMaxMin.maxmin;
      else replayerMaxMin = { id: action.id, maxmin: 'YES' };

      return { ...state, replayerMaxMin };
    }

    case types.SWITCH_VOICE_BROADCAST: {
      return { ...state, switchVoiceBroadcast: { ...action } };
    }

    case types.MASTER_LIVE_ALERT: {
      return { ...state, masterLive: { ...action } };
    }

    case types.MASTER_VIDEO_ALERT: {
      return { ...state, masterVideo: { ...action } };
    }

    case types.CANDIDATE_ACTIVITY_ALERT: {
      return { ...state, candidateActivitiy: { ...action } };
    }

    case types.CANDIDATE_DISCONNECT : {
      const { uid } = action.data;
      const candidates = state.candidates || [];
      const indexIfExisted = _.findIndex(candidates, { id: parseInt(uid) });
      if (indexIfExisted !== -1) {
        const existed = candidates[indexIfExisted];
        delete existed.online;
        return {
          ...state,
          candidateActivitiy: {
            alertType: 'error',
            message: `Candidate ${existed.full_name} disconnected`
          }
        };
      }

      return state;
    }

    case types.END_LCI_FOR_USER: {
      const endingInterviews = state.endingInterviews || [];
      const indexIfExisted = _.findIndex(endingInterviews, { userId: action.userId });
      if (indexIfExisted !== -1) {
        const current = { ...endingInterviews[indexIfExisted], message: action.message, type: null };
        endingInterviews.splice(indexIfExisted, 1, current);
      } else endingInterviews.push({ userId: action.userId, message: action.message, done: action.done });

      return { ...state, endingInterviews, endLCIForUser: action.userId };
    }

    case types.END_LCI_FOR_USER_SUCCESS: {
      const info = get(['result'], action) || {};
      const endingInterviews = state.endingInterviews || [];
      const indexIfExisted = _.findIndex(endingInterviews, { userId: info.userId });
      if (indexIfExisted !== -1) {
        const current = { ...endingInterviews[indexIfExisted], message: info.message || `Ended, cases passed: ${info.totalScoreByCases}`, type: 'success' };
        endingInterviews.splice(indexIfExisted, 1, current);
      }

      return { ...state, endingInterviews };
    }

    case types.END_LCI_FOR_USER_ERROR: {
      const info = get(['result'], action) || {};
      const endingInterviews = state.endingInterviews || [];
      const indexIfExisted = _.findIndex(endingInterviews, { userId: info.userId });
      if (indexIfExisted !== -1) {
        const current = { ...endingInterviews[indexIfExisted], message: info.message || 'End Error', type: 'error' };
        endingInterviews.splice(indexIfExisted, 1, current);
      }

      return { ...state, endingInterviews };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_SETUP_ROOT, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'lciMonitoring';

export default { reducer, stateKey };
